const lithiumIonBatteriesPortalData = {
  images: {
    desktop:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1920,f_auto/v1720213000/assets/market/lithium-ion-batteries/portal/Lithium_ion_batteries_-_Background_3x_e6fbfu.png?_i=AA',
    mobile:
      'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,w_1024,f_auto/v1720213000/assets/market/lithium-ion-batteries/portal/Lithium_ion_batteries_-_Background_3x_e6fbfu.png?_i=AA',
  },
  subTitle: 'Benchmark’s Lithium ion Batteries service gives users access to:',
  listItems: [
    'Benchmark’s latest price assessments',
    'EV battery supply chain indexes',
    'Long-term forecasts: Supply, demand, prices',
    'Comprehensive cost dynamics',
    'Full supply chain visibility: from refinery to market',
  ],
}

export default lithiumIonBatteriesPortalData
